import React, { useRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Editor } from '@tinymce/tinymce-react';
import { useParams } from 'react-router-dom';
import { join } from 'lodash';

const TextEditor = (props) => {
  const {
    name,
    isObject = props?.isObject ?? false,
    compLang = props?.lang ?? "en",
    height = 400,
    autoresize = false,
    ...restProps
  } = props;

  const { lang } = useParams();
  const editorRef = useRef();
  const [initText, setInitText] = useState("");
  const startRef = useRef(true);

  return (
    <Controller
      name={name}
      render={({ field }) => {

        if (startRef.current) {
          if (isObject) {
            if (field.value) {
              setInitText(field.value.value)
            } else {
              field.onChange({ lang: compLang, value: "" })
            }
          } else {
            setInitText(field?.value)
          }
          startRef.current = false;
        }

        const plugins = ['lists', 'link', 'image', 'code'];
        if (autoresize) plugins.push('autoresize');
        return (
          <Editor
            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
            onInit={(evt, editor) => editorRef.current = editor}
            initialValue={initText ? initText : ""}
            init={{
              height: height,
              menubar: true,
              promotion: false,
              branding: false,
              plugins: join(plugins, ' '),
              toolbar: 'undo redo | formatselect | ' +
                'bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | link image code',
              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
              language: lang === 'fr' && 'fr_FR',
            }}
            onEditorChange={(content) => {
              if (isObject) {
                field.onChange({ lang: compLang, value: content })
              } else {
                field.onChange(content)
              }
            }}
            {...restProps}
          />
        )
      }}
    />
  )
};

export default TextEditor;
